import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" }
const _hoisted_2 = { class: "text-lg font-bold capitalize text-slate-900" }
const _hoisted_3 = { class: "max-h-[75vh] overflow-y-auto bg-white" }
const _hoisted_4 = { class: "divide-y divide-slate-100" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[180px_1fr] md:items-start" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[180px_1fr] md:items-start" }
const _hoisted_7 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[180px_1fr] md:items-start" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[180px_1fr] md:items-start" }
const _hoisted_9 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[180px_1fr] md:items-start" }
const _hoisted_10 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_11 = { class: "grid grid-cols-1 gap-3 px-5 py-4 md:grid-cols-[180px_1fr] md:items-start" }
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "flex items-center justify-end gap-3 border-t border-slate-200 bg-slate-50 px-5 py-4" }
const _hoisted_15 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppSelect = _resolveComponent("AppSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "fixed z-[998] bg-black top-0 right-0 w-full h-screen opacity-[0.4]" }, null, -1)),
    _createElementVNode("div", {
      class: "fixed inset-0 z-[999] flex items-center justify-center p-4",
      onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
    }, [
      _createElementVNode("div", {
        ref: "modalContent",
        class: "w-full max-w-[760px]",
        onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("form", {
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
          class: "overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
              _cache[12] || (_cache[12] = _createElementVNode("p", { class: "mt-1 text-sm text-slate-500" }, "Catat histori penyaluran dana bantuan kepada mahasiswa penerima manfaat.", -1))
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "rounded-lg p-1.5 text-slate-400 transition hover:bg-slate-100 hover:text-slate-700",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
            }, [...(_cache[13] || (_cache[13] = [
              _createElementVNode("svg", {
                class: "h-5 w-5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ]))])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[14] || (_cache[14] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Nama Lengkap "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nama lengkap mahasiswa penerima bantuan.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localData.nama) = $event)),
                  required: "",
                  type: "text",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. Budi Santoso"
                }, null, 512), [
                  [_vModelText, _ctx.localData.nama]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[15] || (_cache[15] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("NIM "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Nomor Induk Mahasiswa.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localData.nim) = $event)),
                  required: "",
                  type: "text",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. 13512345"
                }, null, 512), [
                  [_vModelText, _ctx.localData.nim]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[16] || (_cache[16] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Program Studi "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Fakultas atau Program Studi.")
                ], -1)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localData.program_studi) = $event)),
                  required: "",
                  type: "text",
                  class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                  placeholder: "mis. Teknik Informatika"
                }, null, 512), [
                  [_vModelText, _ctx.localData.program_studi]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[17] || (_cache[17] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Jenis Bantuan "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Kategori bantuan yang disalurkan.")
                ], -1)),
                _createVNode(_component_AppSelect, {
                  modelValue: _ctx.localData.jenis_bantuan,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localData.jenis_bantuan) = $event)),
                  options: ['Biaya UKT', 'Biaya Hidup', 'Biaya Tugas Akhir', 'Biaya Kesehatan', 'Bantuan Orang Tua Asuh', 'Bantuan Lainnya'],
                  "button-class": "bg-slate-50 text-slate-800 focus:ring-blue-500/20"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[18] || (_cache[18] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Periode Penyaluran "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Bulan dan tahun penyaluran.")
                ], -1)),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_AppSelect, {
                    modelValue: _ctx.localData.bulan,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localData.bulan) = $event)),
                    options: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'],
                    "button-class": "bg-slate-50 text-slate-800 focus:ring-blue-500/20"
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localData.tahun) = $event)),
                    required: "",
                    type: "text",
                    class: "block w-full rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-800 focus:border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-500/20",
                    placeholder: "Tahun"
                  }, null, 512), [
                    [_vModelText, _ctx.localData.tahun]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[20] || (_cache[20] = _createElementVNode("div", null, [
                  _createElementVNode("label", { class: "text-sm font-semibold text-slate-900" }, [
                    _createTextVNode("Jumlah Bantuan "),
                    _createElementVNode("span", { class: "text-red-500" }, "*")
                  ]),
                  _createElementVNode("p", { class: "mt-0.5 text-xs text-slate-400" }, "Total nominal dana yang disalurkan.")
                ], -1)),
                _createElementVNode("div", _hoisted_12, [
                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" }, [
                    _createElementVNode("span", { class: "text-sm font-bold text-slate-400" }, "Rp")
                  ], -1)),
                  _createElementVNode("input", {
                    value: _ctx.formattedAmount,
                    required: "",
                    type: "text",
                    class: "block w-full pl-10 pr-4 py-2 text-sm font-bold text-indigo-700 bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500/20 transition-all",
                    placeholder: "0",
                    onInput: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAmountInput && _ctx.onAmountInput(...args)))
                  }, null, 40, _hoisted_13)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args))),
              class: "rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
            }, " Batal "),
            _createElementVNode("button", {
              type: "submit",
              disabled: _ctx.isLoading,
              class: "rounded-lg bg-[#003793] px-6 py-2 text-sm font-bold text-white shadow-sm hover:bg-blue-800 disabled:cursor-not-allowed disabled:opacity-60 transition-all"
            }, _toDisplayString(_ctx.isLoading ? 'Menyimpan...' : 'Simpan Data'), 9, _hoisted_15)
          ])
        ], 32)
      ], 512)
    ])
  ], 64))
}